<template>
  <div class="number-hero-container">
    <div class="hero-container">
      <div
        v-if="loading"
        class="hero-number"
      >
        <img
          src="@shared/assets/img/general/loading-white.svg"
          alt="Loading"
          class="loading-img"
        >
      </div>
      <div
        v-else
        class="hero-number blue-text"
      >
        {{ getNumberLocale(allTime) }}
      </div>
      <div class="header">
        INSTALLED HARDWARE UNITS
      </div>
      <router-link
        :to="`/adoption/installations?techId=${selectedTech.id}`"
        class="link"
      >
        See Most Recent
      </router-link>
    </div>
    <div class="hero-container">
      <div
        v-if="loading"
        class="hero-number"
      >
        <img
          src="@shared/assets/img/general/loading-white.svg"
          alt="Loading"
          class="loading-img"
        >
      </div>
      <div
        v-else
        class="flex-row align-center"
      >
        <div
          class="hero-number green-text"
        >
          {{ allTime ? getNumberLocale(Math.round(verifiedCount / allTime * 100)) : 0 }}%
        </div>
        <div class="verification-badge-container">
          <img
            class="verification-badge"
            src="@shared/assets/img/general/verification-badge.svg"
            alt="badge"
          >
          <div class="tooltip">
            <b>Verified Installation</b>
            <br>
            A Verified Unit is a SmartAC.com
            Hardware Kit that has passed these installation checks:
            <ol>
              <li>Do all installs have a pro user associated?</li>
              <li>Is the Hub online?</li>
              <li>Are all sensors online?</li>
              <li>Do Water Sensors in a drain pan have a water riser installed?</li>
              <li>Is the Comfort Sensor in an acceptable location?</li>
              <li>Has the nameplate photo been properly captured?</li>
              <li>Have the risk questions been answered?</li>
              <li>Is the connectivity on all devices acceptable?</li>
            </ol>
          </div>
        </div>
      </div>
      <div class="header">
        VERIFIED INSTALLS
      </div>
      <router-link
        :to="`/adoption/installations?unverified=true&techId=${selectedTech.id}`"
        class="link"
      >
        See All Issues
      </router-link>
    </div>
    <div class="hero-container">
      <div
        v-if="loading"
        class="hero-number"
      >
        <img
          src="@shared/assets/img/general/loading-white.svg"
          alt="Loading"
          class="loading-img"
        >
      </div>
      <div
        v-else
        class="hero-number orange-text"
      >
        {{ allTime ? getNumberLocale(Math.round(customerPurchases / allTime * 100)) : 0 }}%
      </div>
      <div class="header">
        MEMBERS PURCHASED ITEMS
      </div>
      <router-link
        :to="`/member-order?techId=${selectedTech.id}&corpId=${selectedTech.corporationId}`"
        class="link"
      >
        See All Orders
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import technicianMixin from '@shared/mixins/technicianMixin';
import formatterMixin from '@shared/mixins/formatterMixin';

import apiClient from '@shared/lib/general/apiClient';

export default {
  name: 'NumberHero',
  mixins: [technicianMixin, formatterMixin],
  data() {
    return {
      allTime: 0,
      verifiedCount: 0,
      customerPurchases: 0,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      adminFilter: (state) => state.admin.adminFilter || {},
    }),
  },
  watch: {
    selectedTech() {
      this.getOverview();
    },
  },
  mounted() {
    this.getOverview();
  },
  methods: {
    async getOverview() {
      this.loading = true;
      if (this.selectedTech.id) {
        if (this.selectedTech.corporationId) {
          this.$store.dispatch('changeAdminValues', [{
            field: 'adminFilter',
            value: {
              ...this.adminFilter,
              corpId: this.selectedTech.corporationId,
              corpName: this.selectedTech.companyName,
            },
          }]);
        }
        try {
          const { data } = await apiClient({
            method: 'GET',
            url: `/adoption/stat/tech/${this.selectedTech.id}/detail`,
          });
          if (data.length) {
            const {
              allTime,
              verifiedCount,
              customerPurchases,
            } = data[0];
            this.allTime = allTime;
            this.customerPurchases = customerPurchases;
            this.verifiedCount = verifiedCount;
          }
        } catch (err) {
          console.error(err);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.number-hero-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  .hero-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: $N95;
    padding: 24px 0;
    border-radius: 8px;
    &:not(:last-child) {
      margin-right: 24px;
    }
    .hero-number {
      font-size: 3.5rem;
      &.blue-text {
        color: #7B9EFF;
      }
      &.green-text {
        color: $FRESH;
      }
      &.orange-text {
        color: $SUNSET100;
      }
    }
    .header {
      color: $WHITE;
      font-size: 0.875rem;
      font-weight: 700;
      white-space: nowrap;
      line-height: 1;
      margin-bottom: 8px;
      text-transform: uppercase;
    }
    .link {
      color: $N40;
      font-weight: 500;
      font-size: 0.6875rem;
      text-decoration: underline;
    }
    .verification-badge {
      width: 32px;
      height: 32px;
      margin-left: 5px;
    }
    .verification-badge-container {
      position: relative;
      cursor: pointer;
      &:hover {
        .tooltip {
          display: flex;
          flex-direction: column;
        }
      }
    }
    .tooltip {
      position: absolute;
      width: 350px;
      background-color: $SUNSET100;
      color: $BLACK;
      align-items: flex-start;
      justify-content: center;
      border-radius: 4px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      padding: 10px 10px;
      z-index: 1;
      top: 100%;
      left: -150px;
      display: none;
    }
  }
}
</style>
